export function mustParseInt(str: string, radix = 10) {
  const parsed = parseInt(str, radix);
  if (Number.isNaN(parsed)) {
    throw new Error(`Could not parse "${str}" as an integer`);
  }
  return parsed;
}
